import { css } from "@emotion/css";

import { Text } from "@certn/cascadia-react";
import { getTextStyle } from "@certn/cascadia-react/foundations/typography/styles";

type Props = {
  name: string | React.ReactNode;
  value: string | React.ReactNode;
  displayRow?: boolean;
  displayFullWidth?: boolean;
  className?: string;
};

export function DataField(props: Props) {
  const { displayRow = false, displayFullWidth = false, className } = props;
  return (
    <div
      className={css(
        styles.container,
        className,
        displayRow && { flexDirection: "row" }
      )}
    >
      <Text
        style="global/heading-medium"
        className={
          displayFullWidth ? styles.fullWidthName : styles.fixedWidthName
        }
      >
        {props.name}
      </Text>
      <Text style="global/body-primary" className={styles.value}>
        {props.value}
      </Text>
    </div>
  );
}

const styles = {
  container: css({
    display: "flex",
    flexDirection: "column",
    paddingBlockStart: "var(--space-1)",
    paddingBlockEnd: "var(--space-2-5)",
  }),
  fixedWidthName: css({
    width: "160px",
    minWidth: "160px",
  }),
  fullWidthName: css({
    width: "100%",
  }),
  value: css(getTextStyle("global/body-primary")),
};
